/**
 * Sefelly sets the cookie in the browser.
 */
export const setCookie = (cookie: string) => {
  // eslint-disable-next-line no-restricted-globals
  document.cookie = cookie;
};
